import React, { useContext } from "react";
import TextField from "@material-ui/core/TextField";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import { isDisplayable } from "util/misc";
import _ from "lodash";

const GameField = ({
  handleInputChange,
  handleInputBlur,
  activeEntity,
  inputName,
  label,
  disabled,
  transform,
  helperText,
  id
}) => {
  const { styles } = useContext(PlayByPlayContext);
  const formatValue = (val) => {
    const output = isDisplayable(val) ? val : null;
    return transform ? transform(output) : output;
  };

  const value = formatValue(_.get(activeEntity, inputName));

  return (
    <TextField
      id={inputName}
      label={label}
      onChange={(event) => handleInputChange(event, inputName, id)}
      onBlur={handleInputBlur}
      value={isDisplayable(value) ? value : ""} // prevent value from being null: https://reactjs.org/docs/forms.html#controlled-input-null-value
      variant="filled"
      disabled={disabled}
      className={styles.input}
      helperText={helperText}
      InputLabelProps={{
        shrink: true
      }}
    />
  );
};

export default GameField;
